export const fuelingDiscovery = `
# Fueling Discovery
</br></br>
<div id="video"> https://www.youtube.com/embed/0d4Vui6VJa4?si=RwXGV9NvZ3V10xa </div>
</br></br><div style="margin:auto; text-align:center;">
<p>Kwik Fill Country contains amazing attractions and destinations, of which some you might not even be aware.</p>
</br></br>
<a href="https://www.fuelingdiscovery.com" id="button" target="_blank">Learn More</a><a href="/win" id="button" target="_blank">Enter Giveaway</a>
</div></br></br>
</br></br>`